import React from 'react'
import { BrowserRouter as Router, Switch } from 'react-router-dom'
import './theme.ts'
import routes from './routes'
import 'flex.css/dist/data-flex.css'

export default function App() {
  return (
    <Router>
      <Switch>
        {routes()}
      </Switch>
    </Router>
  )
}
